import React from 'react';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

import DocumentIcon from '@material-ui/icons/Archive';
import configuration from '../../utils/config.js';

//http://localhost:8000/documents/2/1549503546__inv_rpt_kardex_10_01_2019_095643.xlsx
//<a href={'http://localhost:8000/' + record.filepath + record.file}  target="_blank" rel="noopener noreferrer" > 

//http://hmpgroup.bitcliker.com/documents/api/documents/4/1549589900__screencapture-bitcliker-2019-02-07-17_28_38.png
//<a href={'http://hmpgroup.bitcliker.com/documents/api/' + record.filepath + record.file} target="_blank" rel="noopener noreferrer" > 

const LinkToDocument = ({ record, translate }) => (
   <Tooltip title="Download attached document">
      <Button>
        <a href={configuration.urlDocuments + record.filepath + record.file}  target="_blank" rel="noopener noreferrer" > 
          <DocumentIcon  />
        </a>
      </Button>
    </Tooltip>
);



export default  LinkToDocument ;
